module.exports = {
    servers: {
        base: process.env.REACT_APP_BASE_SERVER,
    },
};
